import BlockIcon from "@mui/icons-material/Block";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import styles from "./AccountInactive.module.scss";
import pplogo from "../../assets/logos/ca-logo-master-green.png";
import { EmptyLayout } from "../../layouts/Layouts";
import { signinRedirect } from "../../store/modules/auth/authServices";

function AccountInactive() {
  return (
    <EmptyLayout>
      <Grid container spacing={0} direction="column" alignItems="center" className={styles["AccountInactive"]}>
        <Grid item>
          <BlockIcon sx={{ color: "var(--custom-color-red)", fontSize: 80 }} />
        </Grid>
        <Grid item className={styles["AccountInactive-description"]}>
          <p>Your account is no longer active. Please contact Camp Australia if you believe this is an error.</p>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={() => signinRedirect()}>
            Back to Sign In
          </Button>
        </Grid>
        <Grid item className={styles["AccountInactive-logo"]}>
          <img src={pplogo} alt="Camp Australia" />
        </Grid>
      </Grid>
    </EmptyLayout>
  );
}

export default AccountInactive;
